import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageAvailabilitySection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsAvailability, {
      state: { optionData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Availability and Pricing</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Availability</p>
              <p className="text-secondary">
                {optionData?.availability === "fixed_time_slots"
                  ? "Fixed Time Slots"
                  : optionData?.availability === "operating_hours"
                  ? "Operating Hours"
                  : "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Pricing</p>
              <p className="text-secondary">
                {optionData?.pricingOption === "fixed" || "age_group"
                  ? "Price Per Person"
                  : "Price Per Group/Vehicle"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
